import WizCoLoader from './WizCoLoader.vue'
import { inject } from 'vue'
import { createPinia } from 'pinia'
import { StoryblokVue, apiPlugin } from '@storyblok/vue'
import { version } from '../package.json'

import SharedComponents from '@webcarelbj/shared-components'
import CuraPick from '@webcarelbj/curapick'
import BedmatPick from '@webcarelbj/bedmatpick'

import WizcoStepDynamic from './views/WizcoStepDynamic.vue'
import WizcoStepForm from './views/WizcoStepForm.vue'
import WizcoStepInformation from './views/WizcoStepInformation.vue'
import WizcoStepSelection from './views/WizcoStepSelection.vue'
import WizcoStepProductSelection from './views/WizcoStepProductSelection.vue'
import WizcoStepDocumentsView from './views/WizcoStepDocumentsView.vue'

import EnrichedPflegeAutocomplete from './components/input/EnrichedPflegeAutocomplete.vue'
import EnrichedPflegeCheckbox from './components/input/EnrichedPflegeCheckbox.vue'
import EnrichedPflegeInput from './components/input/EnrichedPflegeInput.vue'
import EnrichedPflegeRadio from './components/input/EnrichedPflegeRadio.vue'

import RichtextResolver from './components/storyblok/RichtextResolver.vue'
import Alertbox from './components/storyblok/shared/Alertbox.vue'
import Card from './components/storyblok/shared/Card.vue'
import Divider from './components/storyblok/shared/Divider.vue'
import Tooltip from './components/storyblok/shared/Tooltip.vue'
import WPElementButton from './components/storyblok/shared/WPElementButton.vue'

export default {
  install(
    app,
    options = {
      storyblokVersion: 'public',
      storyblokAccessToken: '',
      apiDomain: '',
      listApiDomain: '',
      disableStoryblokPlugin: false,
      apiDomainDecision: '',
      apiDomainProduct: ''
    }
  ) {
    try {
      if (!options.apiDomain) {
        throw new Error('apiDomain missing')
      }
      if (!options.listApiDomain) {
        throw new Error('listApiDomain missing')
      }
      if (!options.apiDomainDecision) {
        throw new Error('apiDomainDecision missing')
      }
      if (!options.apiDomainProduct) {
        throw new Error('apiDomainProduct missing')
      }
      //  storyblokAccessToken only when disableStoryblokPlugin is false
      if (!options.disableStoryblokPlugin && !options.storyblokAccessToken) {
        throw new Error('storyblokAccessToken missing')
      }

      if (!app.config.globalProperties.$sharedComponentsInitialized) {
        app.use(SharedComponents)
      }

      //  Set global const
      app.provide('WIZCO_API_DOMAIN', options.apiDomain)
      app.provide('WIZCO_STORYBLOK_VERSION', options.storyblokVersion)
      app.provide('WIZCO_STORYBLOK_TOKEN', options.storyblokAccessToken)
      app.provide('WIZCO_LIST_API_DOMAIN', options.listApiDomain)

      //  Storyblok plugin
      if (!options.disableStoryblokPlugin) {
        app.use(StoryblokVue, {
          accessToken: options.storyblokAccessToken,
          use: [apiPlugin]
        })
      }

      //  Check if pinia is already initialized, if not, init now but use our plugin for sure
      let pinia = app.config.globalProperties.$pinia

      const wizcoPiniaConfig = ({ store }) => {
        store.$WIZCO_API_DOMAIN = inject('WIZCO_API_DOMAIN')
        store.$WIZCO_STORYBLOK_VERSION = inject('WIZCO_STORYBLOK_VERSION')
        store.$WIZCO_STORYBLOK_TOKEN = inject('WIZCO_STORYBLOK_TOKEN')
      }

      if (pinia) {
        pinia.use(wizcoPiniaConfig)
      } else {
        pinia = createPinia()
        pinia.use(wizcoPiniaConfig)
        app.use(pinia)
      }

      //  CuraPick plugin
      if (!app.config.globalProperties.$curapickPluginInitialized) {
        app.use(CuraPick, {
          apiDomainDecision: options.apiDomainDecision,
          apiDomainProduct: options.apiDomainProduct
        })
      }

      //  BedmatPick plugin
      if (!app.config.globalProperties.$bedmatpickPluginInitialized) {
        app.use(BedmatPick, {
          apiDomainDecision: options.apiDomainDecision
        })
      }

      /**
       * Global components
       * It's best to prefix them with Wizco to not have multiple components with the
       * same name in the parent project.
       */
      app.component('WizcoStepDynamic', WizcoStepDynamic)
      app.component('WizcoStepForm', WizcoStepForm)
      app.component('WizcoStepInformation', WizcoStepInformation)
      app.component('WizcoStepSelection', WizcoStepSelection)
      app.component('WizcoStepProductSelection', WizcoStepProductSelection)
      app.component('WizcoStepDocumentsView', WizcoStepDocumentsView)
      app.component('EnrichedPflegeAutocomplete', EnrichedPflegeAutocomplete)
      app.component('EnrichedPflegeCheckbox', EnrichedPflegeCheckbox)
      app.component('EnrichedPflegeInput', EnrichedPflegeInput)
      app.component('EnrichedPflegeRadio', EnrichedPflegeRadio)
      app.component('WizcoAlertbox', Alertbox)
      app.component('WizcoCard', Card)
      app.component('WizcoDivider', Divider)
      app.component('WizcoTooltip', Tooltip)
      app.component('WizcoWPElementButton', WPElementButton)
      app.component('WizcoRichtextResolver', RichtextResolver)

      //  Main component
      app.component('WizCo', WizCoLoader)

      //  Set state so other apps can react to it
      app.config.globalProperties.$wizcoPluginInitialized = true

      console.group(
        '%cpflege.de %cWizCo',
        'background-color: #f1f7f7; color: #005b85; font-weight: 900',
        'background-color: #f1f7f7; color: #ed6976; font-style: italic; font-weight: 400'
      )
      console.info(`%cVersion: %c${version}`, 'color: #005b85', 'font-weight: 900')
      console.info('%cRun by: 🦄', 'color: hotpink')
      console.groupEnd()
    } catch (error) {
      console.error(`WizCo: Error while initializing plugin: ${error.message}.`)
    }
  }
}
